import React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { useTranslation } from 'react-i18next';
import './BotCard.css';
function BotCard ({ data, permissions }) {
    const { t } = useTranslation();
    return (
        <div id="botcard-container" data-test="bot-card">
            <h3>{t('CONTENT.BOT-DETAILS.BOT-CARD')}</h3>
            <hr />
            <table>
                <tbody>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.DEVELOPER')}:</th>
                        <td>{/* <img src={logo} alt="developer logo" width="100" /> */}</td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.PRICE')}:</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.TAGS')}:</th>
                        <td>
                            <span className="content-with-icon">
                                <LocalOfferIcon />&nbsp;{data?.tags}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.APPLICATION')}:</th>
                        <td className="bot-table-list">
                            {data?.applications?.map((item, itemI) => {
                                return (<span key={itemI}>{item.name}</span>);
                            })}
                            {/* <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/SAP_2011_logo.svg/330px-SAP_2011_logo.svg.png" alt="application logo" width="50" />
                            <br />
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Microsoft_Excel_2013_logo.svg/1043px-Microsoft_Excel_2013_logo.svg.png" alt="application logo" height="25" /> */}
                        </td>
                    </tr>
                    <tr>
                        <th className="bot-table-list">{t('CONTENT.BOT-DETAILS.CATEGORY')}:</th>
                        <td>
                            {data?.categories?.map((item, itemI) => {
                                return (<span key={itemI}>{item.name}</span>);
                            })}
                        </td>
                    </tr>
                    <tr>
                        <th className="bot-table-list">{t('CONTENT.BOT-DETAILS.BUSINESS-PROCESS')}:</th>
                        <td>
                            {data?.business_processes?.map((item, itemI) => {
                                return (<span key={itemI}>{item.name}</span>);
                            })}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.AUTOM-SECURITY-STAGE')}:</th>
                        <td>{data?.security_stage?.name}</td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.LAST-UPDATE-DATE')}:</th>
                        <td>{new Date(data?.updated_at).toLocaleString(t('CONTENT.CREDENTIAL-TAB.LOCALE'))}</td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.DATE-OF-BIRTH')}:</th>
                        <td>{new Date(data?.created_at).toLocaleString(t('CONTENT.CREDENTIAL-TAB.LOCALE'))}</td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.DOWNLOAD-TIMES')}:</th>
                        <td>{data?.bot_details?.download_count}</td>
                    </tr>
                    <tr>
                        <th>{t('CONTENT.BOT-DETAILS.SUPPORT')}:</th>
                        <td>{data?.bot_details?.support}</td>
                    </tr>
                </tbody>
            </table>
            <div id="botcard-download">
                {permissions?.includes('AUTOMSTORE_DOWNLOAD') &&
                <button data-test="download-button">
                    <div className="content-with-icon"><GetAppIcon />&nbsp;{t('CONTENT.BOT-DETAILS.DOWNLOAD')}</div>
                </button>}
            </div>
        </div>
    );
}

export default BotCard;
